<template>
  <div
    class="company-email-endings"
    >
    <div class="company-email-endings-list">
      <div
        class="company-email-endings-list-entry"
        v-for="bemail in getUObjects({type: 'bemails', ids: business.bemails})"
        :key="bemail.id"
        @click="$router.push({
          name: 'CompanyEmailEndingsDetails',
          params: {
            email_endings_id: bemail.id
          }
          })"
        >
        @{{bemail.value}}
      </div>
    <div class="company-email-endings-add-btn green" color="green"
      @click="$router.push({
        name: 'CompanyEmailEndingsCreate',
        })"
      >
      <v-icon>add</v-icon>add mail ending
    </div>
    </div>
    <div class="company-email-endings-details">
      <router-view/>
    </div>
  </div>
</template>
<script>
  import { mapGetters, mapActions } from 'vuex';
  export default {
    props: [],
    data: () => ({
    }),
    created() {
      this.requestUObject({
        url: [
          {businesses: this.business.id},
          {bemails: ''},
          {showWithEntitiesNormalized: ''}
        ],
        add_u_object: true
      })
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects',
      ]),
      business() {
        let current_user = this.$store.getters['Auth/getUser'];
        return this.$store.state.Ultra.businesses[current_user.business.id];
      }
    },
    methods: {
      ...mapActions('Ultra', [
        'requestUObject',
      ]),
    }
  }
</script>
<style>
  .company-email-endings {
    position: relative;
    width: 100%;
    display: flex;
    overflow: hidden;
  }
  .company-email-endings-list {
    position: relative;
    height: 100%;
    width: 40%;
    overflow: auto;
  }
  .company-email-endings-details {
    width: 60%;
    border-left: 1px solid white;
  }
  .company-email-endings-list-entry {
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    border-bottom: solid white 1px;
    user-select: none;
    cursor: pointer;
  }
  .company-email-endings-list-entry:hover {
    background-color: grey;
  }
  .company-email-endings-add-btn {
    position: sticky;
    bottom: 0px;

    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 10px;
    border-bottom: solid white 1px;
    user-select: none;
    cursor: pointer;
  }
</style>
